




































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { activityFields } from '@/config/activities';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import moment from 'moment';
import { Activity } from '@activities/interfaces/activity';
import Colorpicker from '@shared/components/forms/inputs/colorpicker/colorpicker.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import Time from '@shared/components/forms/inputs/time/time.vue';
import TrainingCard from '@activities/components/cards/training-card/training-card.vue';
import DayTimeRepeater from '@shared/components/forms/inputs/day-time-repeater/day-time-repeater.vue';

@Component({
  name: 'bpc-activity-training-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-datepicker': Datepicker,
    'bpc-switch': Switch,
    'bpc-entity-select': EntitySelect,
    'bpc-colorpicker': Colorpicker,
    'bpc-multi-select': MultiSelect,
    'bpc-time': Time,
    'bpc-training-card': TrainingCard,
    'bpc-day-time-repeater': DayTimeRepeater,
  },
})
export default class ActivityTrainingForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: Activity;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: true }) readonly activityFormIsEditable: boolean;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCancelButton: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: Activity;
  @Prop({
    type: String,
  })
  readonly cancelButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;
  // DATA
  // COMPUTED

  get formModel(): Activity {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }
  get activityId(): string | number {
    return this.formModel?.id || this.modelId || this.$route.params?.id || null;
  }

  get fieldsConfig() {
    return activityFields;
  }

  get currentFile(): object {
    return { id: this.formModel?.activities?.id, url: this.formModel?.activities?.url };
  }

  get savePath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('bpc-activity')}/training/${this.formModel.id}`;
  }

  get selectedTypeDescription() {
    return this.$t(
      this.fieldsConfig.activity_type.options.find(
        item => item.value === this.formModel.activity_type,
      )?.description,
    );
  }

  // LIFECYCLE
  // created(){}
  // updated(){}
  // destroyed(){}

  // METHODS
  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({
      text: 'core.superadmin_form_update_errors',
    });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  onFileUploaded(file) {
    this.formModel.activities = file;
  }

  onFileRemoved() {
    this.formModel.activities = null;
  }

  onChangeTeam(team) {
    this.formModel.team_id = team?.id || null;
  }

  onChangeContact(contact) {
    this.formModel.contact_id = contact?.id || null;
  }

  onChangePeriod(period) {
    this.formModel.period_id = period?.id || null;
    if (period && period.start_date) {
      this.formModel.start_date = period.start_date;
    }
    if (period && period.end_date) {
      this.formModel.end_date = period.end_date;
    }
  }

  // WATCHERS
}
